import { render, staticRenderFns } from "./AdminPages.vue?vue&type=template&id=d2095556&"
import script from "./AdminPages.vue?vue&type=script&lang=js&"
export * from "./AdminPages.vue?vue&type=script&lang=js&"
import style0 from "./AdminPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminPages.vue"
export default component.exports